export default __webpack_public_path__ + "static/media/box2_step3.e13e65bc.png";